export const BASE_URL = "https://datingapi.meander.software";
